import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";
import { getInitials } from "helpers";
import { connect } from "react-redux";
import * as actions from "redux/actions/discoverActions";
import MiniLoader from "components/MiniLoader";
import StockAvatar from "components/StockAvatar";
import { Translate, I18n } from "react-redux-i18n";
import { Trash, Star} from "theme/icon";

const useStyles = {
    root: {},
    content: {
        padding: 0,
    },
    inner: {
        minWidth: 1050,
    },
    nameContainer: {
        display: "flex",
        alignItems: "center",
    },
    actions: {
        justifyContent: "center",
    },
    avatar: {
        marginRight: '7px',
        height: 25,
        width: 25,
        flexDirection: 'row',
        position: "absolute",
        borderRadius: "5px"
    },
};

const stylesLocal = {
    subcell: {
        padding: "5px"
    },
    cell: {
        padding: "5px"
    }
};

function pl(items) {
    var pl = 0;
    items.map(item => {
        pl = pl + (item.open_trade + item.close_trade - item.tax);
    });
    return pl.toFixed(2);
}

const Table_ = (props) => {
    const { className, list, history, ...rest } = props;

    const [selectedList, setSelectedList] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [page, setPage] = useState(0);

    const [filters, setFilters] = useState({
        search: "",
    });

    const handleSelectAll = (event) => {
        const { list } = props;

        let selectedList;

        if (event.target.checked) {
            selectedList = list.map((item) => item.id);
        } else {
            selectedList = [];
        }
        setSelectedList(selectedList);
    };

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedList.indexOf(id);
        let newSelectedList = [];

        if (selectedIndex === -1) {
            newSelectedList = newSelectedList.concat(selectedList, id);
        } else if (selectedIndex === 0) {
            newSelectedList = newSelectedList.concat(selectedList.slice(1));
        } else if (selectedIndex === selectedList.length - 1) {
            newSelectedList = newSelectedList.concat(selectedList.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelectedList = newSelectedList.concat(
                selectedList.slice(0, selectedIndex),
                selectedList.slice(selectedIndex + 1)
            );
        }

        setSelectedList(newSelectedList);
    };

    const handlePageChange = (event, page) => {
        setPage(page);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(event.target.value);
    };

    const onClickIn = (item) => {
        // props.setPatient(item);
    };

    const onClickDelete = (item) => {
        props.removeItem(props.token, { patient_id: item.id, id: props.user_id });
    };

    const onClickLoadMore = () => {
        if (props.loadingMore || props.pageSize < 25) {
            return;
        }
        props.loadMore(
            {
                index: props.list.length,
                id: props.user_id,
            },
            props.token,
        );
    };


    useEffect(() => {
        //props.loadListDividend({ id: props.user_id }, props.token);
        props.loadList({ id: props.user_id }, props.token);
    }, []);

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const normalizedSearch = filters.search.toLowerCase();
    const isOtcExchange = (exchange) => {
        const ex = String(exchange || '').trim().toUpperCase();
        if (!ex) {
            return false;
        }
        if (ex.includes('OTC')) {
            return true;
        }
        return /^(PINK|GREY|GRAY|OTCPK|OTCQX|OTCQB|OTCBB|XOTC)$/.test(ex);
    };
    const filteredList = list.filter((item) => {
        if (isOtcExchange(item.exchange)) {
            return false;
        }
        if (!normalizedSearch) {
            return true;
        }
        return (
            item.symbol.toLowerCase().includes(normalizedSearch) ||
            (item.name && item.name.toLowerCase().includes(normalizedSearch)) ||
            (item.exchange && item.exchange.toLowerCase().includes(normalizedSearch))
        );
    });

    return (
        <div className="">
                <div className={''}>
                   
                    <table className="table table-hover table-fixed discover-table">
                        <thead>
                            <tr>
                                <th align="left">Symbol</th>
                                <th>Name</th>
                                <th>Exchange</th>
                                <th align="right">Last</th>
                                <th align="right">Earning date</th>
                                <th align="right">Information</th>
                                <th align="right">Estimation</th>
                                <th align="right">Surprise</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredList.map((item, rowIndex) => (
                                <tr
                                    className={''}
                                    key={`${item.symbol}-${item.earning_at || rowIndex}`}
                                    selected={selectedList.indexOf(item.id) !== -1}
                                >
                                    <th style={stylesLocal.cell}>
                                        <div className="discover-symbol-cell">
                                            <StockAvatar item={item} symbol={item.symbol} className="avatar-md" />
                                            <div className="discover-symbol-meta">
                                                <RouterLink
                                                    to={"/stock/" + item.symbol}
                                                    className="discover-symbol-link"
                                                >
                                                    {item.symbol.toUpperCase()}
                                                </RouterLink>
                                                {item.dividend === "1" && (
                                                     <Star size={20}/>
                                                )}
                                            </div>
                                        </div>
                                    </th>
                                    <th style={stylesLocal.cell}>{item.name}</th>
                                    <th style={stylesLocal.cell}>{item.exchange}</th>
                                    <th style={stylesLocal.cell} align="right">
                                        {'$ '}{item.price}
                                    </th>
                                    <th style={stylesLocal.cell} align="right">
                                        {moment(item.earning_at).zone("+00:00").format('DD/MM/YYYY')}
                                    </th>
                                    <th style={stylesLocal.cell} align="right">
                                        {item.information}
                                    </th>
                                    <th style={stylesLocal.cell} align="right">
                                        {item.estimation}
                                    </th>
                                    <th style={stylesLocal.cell} align="right">
                                        {item.surprise}
                                    </th>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            {/* </PerfectScrollbar> */}
            <div className="discover-table-footer">
                {props.pageSize === 25 && (
                    props.loadingMore ? (
                        <MiniLoader />
                    ) : (
                        <button className="btn btn-primary" onClick={onClickLoadMore}>
                            <Translate value="load_more" />
                        </button>
                    )
                )}
            </div>
        </div >
    );
};

Table_.propTypes = {
    className: PropTypes.string,
    list: PropTypes.array.isRequired,
    history: PropTypes.object
};

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        auth: reducer.session.auth,

        list: reducer.discover.list,
        error: reducer.discover.error,
        loading: reducer.discover.loading,

        loadingMore: reducer.discover.loadingMore,
        pageSize: reducer.discover.page_size,
        pageCount: reducer.discover.page_count,

    };
}

const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadListEarning({ params, token })),
    loadMore: (params, token) =>
        dispatch(actions.loadListEarningScroll({ params, token })),

});
export default connect(mapStateToProps, mapDispatchToProps)(Table_);
/**.slice((page * rowsPerPage), (rowsPerPage * (page + 1)))
 *  <TablePagination
          component="div"
          count={list.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
 * <TableCell>
                      {item.year}
                    </TableCell>
                    <TableCell>
                      {item.color}
                    </TableCell>
                     <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedList.length === list.length}
                      color="primary"
                      indeterminate={
                        selectedList.length > 0 &&
                        selectedList.length < list.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>

                   <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedList.indexOf(item.id) !== -1}
                        color="primary"
                        onChange={(event) => handleSelectOne(event, item.id)}
                        value="true"
                      />
                    </TableCell>
 */
